(function ($) {

'use strict';

	$.cookieHelper = {
		/**
		 * Returns the content of a cookie
		 * @param {type} cookieName
		 * @returns {String} cookie content
		 */
		getCookie: function (cookieName) {
			var name = cookieName + '=';
			var allCookies = document.cookie.split(';');
			for (var i = 0; i < allCookies.length; i++) {
				var cookie = allCookies[i];
				while (cookie.charAt(0) === ' ') {
					cookie = cookie.substring(1);
				}
				if (cookie.indexOf(name) === 0) {
					return decodeURIComponent(cookie.substring(name.length, cookie.length));
				}
			}
			return '';
		},

		/**
		 * Set data for the specified cookie
		 * @param {string} cookieName
		 * @param {string} cookieData
		 * @param {int} cookieExpires expires in milliseconds
		 * @param {string} cookiePath
		 * @returns {undefined}
		 */
		setCookie: function (cookieName, cookieData, cookieExpires, cookiePath) {
			var expires = '';
			var path = '';
			var secure = '';
			var removeOldCookie = false;
			
			if (cookieExpires) {
				var date = new Date();
				date.setTime(date.getTime() + cookieExpires);
				expires = '; expires=' + date.toUTCString();
			}
			if (cookiePath) {
				path = '; path=' + cookiePath;
			} else {
				removeOldCookie = true;
				path = '; path=/';
			}
			if (document.location.protocol === 'https:') {
				secure = '; secure';
			}
			if (removeOldCookie) {
				var date = new Date();
				date.setTime(date.getTime() - 1000);
				document.cookie = encodeURIComponent(cookieName) + '=' + secure + '; expires=' + date.toUTCString();
			}
			document.cookie = encodeURIComponent(cookieName) + '=' + encodeURIComponent(cookieData) + secure + expires + path;
		}
	};	// $.cookieHelper

}(jQuery));